module.exports = __webpack_public_path__ + "img/pro.eed6c2b9.png";